import { render, staticRenderFns } from "./RegionPlans.vue?vue&type=template&id=05ac27e8"
import script from "./RegionPlans.vue?vue&type=script&lang=js"
export * from "./RegionPlans.vue?vue&type=script&lang=js"
import style0 from "./RegionPlans.vue?vue&type=style&index=0&id=05ac27e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports